import { ReactNode } from "react"

const Block = (prop: {children?: ReactNode})=>{
    return <>
        {prop.children}
    </>
}

export default Block;